/**
 * Pro Upgrade Prompt Store
 *
 * Manages the state of the Pro upgrade prompt dialog that appears when a user
 * attempts to use a Pro-only feature in Personal mode.
 *
 * This store provides a centralized way to trigger the UpgradeDialog from any
 * part of the app, especially after receiving a `requires_pro` error from IPC.
 */

import { create } from 'zustand';
import type { ProFeature } from '../types';

interface ProUpgradePromptState {
  /** Whether the upgrade dialog is open */
  isOpen: boolean;
  /** The feature that triggered the upgrade prompt (for highlighting) */
  feature: ProFeature | undefined;

  /**
   * Show the upgrade dialog, optionally highlighting a specific feature.
   * @param feature The feature that requires Pro access
   */
  showPrompt: (feature?: ProFeature) => void;

  /**
   * Hide the upgrade dialog.
   */
  hidePrompt: () => void;
}

export const useProUpgradePromptStore = create<ProUpgradePromptState>((set) => ({
  isOpen: false,
  feature: undefined,

  showPrompt: (feature) =>
    set({
      isOpen: true,
      feature,
    }),

  hidePrompt: () =>
    set({
      isOpen: false,
      feature: undefined,
    }),
}));
